import React from 'react';
import './Loader.css'; // Agrega estilos para el loader si es necesario

const loadingImg = require('../assets/img/chilin-loading.png');

const Loader = () => {
  return (
    <div className="loader-container">
      <img
                        src={loadingImg} /* Ruta de tu imagen de 40x40 */
                        alt="loading"
                        className="loading"
                      />
      <div className="spinner"></div> {/* Un spinner sencillo */}
      <p>Cargando...</p>
    </div>
  );
};

export default Loader;